export enum LanguageLabel {
  ENGLISH = 'English',
  GERMAN = 'Deutsch',
  CZECH = 'Česky',
  POLISH = 'Polski',
  POLISH_BDO = 'Polski BDO',
}
